/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_PausereasonInputs */

const en_entity_pausereason = /** @type {(inputs: Entity_PausereasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause Reason`)
};

const de_entity_pausereason = /** @type {(inputs: Entity_PausereasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausengrund`)
};

/**
* | output |
* | --- |
* | "Pause Reason" |
*
* @param {Entity_PausereasonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_pausereason = /** @type {((inputs?: Entity_PausereasonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_PausereasonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_pausereason(inputs)
	return de_entity_pausereason(inputs)
});